
























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { PermissionValue } from '@/enums/PermissionValue';
import IndicatorGroup from '../../../models/indicator/indicatorGroup.model';
@Component
export default class IndicatorGroupTableComponent extends GenericBTable<IndicatorGroup> {

1
  created() {
    this.permissionValue = PermissionValue.CODIFICACIONES;
    this.tableConfig.controller = "IndicatorGroups"

    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "Nombre", true);
    this.tableConfig.insertColumns(name);
    this.tableConfig.actions.customTemplate = true;

  }
  verOpciones(row: any) {
    this.$router.push(`/indicatorGroup/${row.id}/indicatorType`);
  }
}
